import * as React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';
import { useIntl } from 'react-intl';

const NotPermission = () => {
  const intl = useIntl();
  return (
    <Result
      status="403"
      title="403"
      subTitle={intl.formatMessage({ id: 'message.HTTP_403', defaultMessage: '抱歉，您无权访问此页面。' })}
      extra={(
        <Button type="primary">
          <Link to="/" replace>
            {intl.formatMessage({ id: 'common.BackHome', defaultMessage: '返回首页' })}
          </Link>
        </Button>
      )}
    />
  );
};

export default NotPermission;
